const languages = [
  { code: "en", name: "English" },
  { code: "fr", name: "Français" },
];

export { languages };
